
const initialState = {
  url: undefined
}

export function popUpReducer(state=initialState, {type, payload}) {
  switch(type){
    case "LOAD_POPUP":
      return {
        ...state,
        url: payload
      }
      case "CLEAR_POPUP":
      return {
        ...state,
        url: undefined
      }
      default:
        return state
  }
}